import { render, staticRenderFns } from "./createApplication.vue?vue&type=template&id=134f9050&scoped=true"
import script from "./createApplication.vue?vue&type=script&lang=js"
export * from "./createApplication.vue?vue&type=script&lang=js"
import style0 from "./createApplication.vue?vue&type=style&index=0&id=134f9050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f9050",
  null
  
)

export default component.exports